module.exports = __webpack_public_path__ + "static/img/lectureTwo.a240a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lectureTwo.png
// module id = Gl1I
// module chunks = 1